import React, { useCallback } from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import Columns from './DataComponent__TableColumns';
import Export from './DataComponent__TableExport';
import actions from './DataComponent.actions';

const DataComponentSettings = ({
    settings: propSettings,
    tableBodyTitle: propTableBodyTitle,
    settingKey: propSettingKey,
    headerNames: propHeaderNames,
    loading: propLoading,
    data: propData,
    filters: propFilters,
    sessionId: propSessionId,
    totalRows: propTotalRows
}) => {
    const renderSettings = useCallback(() => {
        if (!propSettings) return null;

        return (
            <React.Fragment>
                <div className={`settingsBar ${propTableBodyTitle ? 'settingsBar--withTitle' : ''}`}>
                    <div>
                        <Columns
                            settingKey={propSettingKey}
                            data={propHeaderNames}
                            onApply={actions.saveServerStorage}
                        />
                    </div>
                    <div>
                        <Export
                            settingKey={propSettingKey}
                            data={propHeaderNames}
                            disabled={propLoading || !(Array.isArray(propData) ? propData.length : Object.keys(propData || {}).length)}
                            filter={propFilters}
                            sessionId={propSessionId}
                            totalRows={propTotalRows}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }, [propSettings, propTableBodyTitle, propSettingKey, propHeaderNames, propLoading, propData, propFilters, propSessionId, propTotalRows]);

    return renderSettings();
};

DataComponentSettings.propTypes = {
    settings: PropTypes.bool,
    tableBodyTitle: PropTypes.string,
    settingKey: PropTypes.string,
    headerNames: PropTypes.array,
    loading: PropTypes.bool,
    data: PropTypes.array,
    filters: PropTypes.object,
    sessionId: PropTypes.string,
    totalRows: PropTypes.number
};

DataComponentSettings.defaultProps = {
    settings: false,
    tableBodyTitle: '',
    settingKey: '',
    headerNames: [],
    loading: false,
    data: [],
    filters: {},
    sessionId: '',
    totalRows: 0
};

export default withTranslation(DataComponentSettings);
